// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".entryLeft {\n  box-shadow: 2px 0px 10px 0px rgba(0, 0, 0, 0.8);\n}\n", "",{"version":3,"sources":["webpack://./src/routes/Main/index.css"],"names":[],"mappings":"AAAA;EACI,+CAAA;AACJ","sourcesContent":[".entryLeft {\n    box-shadow: 2px 0px 10px 0px rgba(0, 0, 0, 0.8);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
